import { map } from "lodash";

import Input from "components/_partials/Input";
import Checkbox from "components/_partials/Checkbox";
import { thingsToLearn } from "constants/thingsToLearn";

interface InteresetSelectionFormProps {
  selectionFormik: any;
  isFormSubmitted: boolean;
  hasError: boolean;
}

const InteresetSelectionForm = (props: InteresetSelectionFormProps) => {
  const { selectionFormik, isFormSubmitted, hasError } = props;

  const handleInterestCheckboxChange = (item: string) => {
    if (selectionFormik.values.selected_favourite.includes(item)) {
      selectionFormik.setFieldValue(
        "selected_favourite",
        selectionFormik.values.selected_favourite.filter(
          (i: string) => i !== item
        )
      );
    } else {
      selectionFormik.setFieldValue("selected_favourite", [
        ...selectionFormik.values.selected_favourite,
        item,
      ]);
    }
  };

  return (
    <div className="w-container">
      <div className="w-form">
        <div className="form">
          <Input
            label="usertesting username"
            name="username"
            type="text"
            value={selectionFormik.values.username}
            onChange={selectionFormik.handleChange}
            isRequired={true}
            errorMsg={selectionFormik.errors.username}
          />
          <Input
            label="email address"
            name="emailAddress"
            type="text"
            isRequired={true}
            value={selectionFormik.values.emailAddress}
            onChange={selectionFormik.handleChange}
            errorMsg={selectionFormik.errors.emailAddress}
          />
          <Input
            label="age of your smart girl"
            name="age"
            type="number"
            isRequired={true}
            value={selectionFormik.values.age}
            onChange={selectionFormik.handleChange}
            errorMsg={selectionFormik.errors.age}
          />
          <div className="field-label">
            <label>
              <strong>
                What are your favorite things to learn about? (Please pick at
                least 5 things)
              </strong>
            </label>
            <div className="w-layout-grid grid">
              {map(thingsToLearn, (thing) => (
                <div key={thing}>
                  <Checkbox
                    name={thing}
                    value={selectionFormik.values.selected_favourite.includes(
                      thing
                    )}
                    onChange={() => handleInterestCheckboxChange(thing)}
                    label={thing}
                  />
                </div>
              ))}
            </div>
            {selectionFormik.errors.selected_favourite &&
              selectionFormik.touched.selected_favourite && (
                <span className="error_text">
                  {selectionFormik.errors.selected_favourite}
                </span>
              )}
          </div>
        </div>
        {isFormSubmitted && (
          <div className="w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
        )}
        {hasError && (
          <div className="w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InteresetSelectionForm;
